import { render, staticRenderFns } from "./analyzeRight.vue?vue&type=template&id=3fcf20e2"
import script from "./analyzeRight.vue?vue&type=script&lang=js"
export * from "./analyzeRight.vue?vue&type=script&lang=js"
import style0 from "./analyzeRight.vue?vue&type=style&index=0&id=3fcf20e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports